import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Snackbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { green, red } from "@material-ui/core/colors";
import {
  AddCircleOutlineRounded,
  Close,
  FavoriteRounded,
  RemoveCircleOutlineRounded,
  ShareRounded,
} from "@material-ui/icons";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import RemoveCircleOutlineOutlinedIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import StarHalfRoundedIcon from "@material-ui/icons/StarHalfRounded";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import clsx from "clsx";
import { firestore } from "firebase";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { db } from "../firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 10,
    maxWidth: 500,
    borderRadius: 12,
    transition:
      ".3s transform cubic-bezier(.155,1.105,.295,1.12),.3s box-shadow,.3s -webkit-transform cubic-bezier(.155,1.105,.295,1.12)",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "9px 8px 0 rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0,0,0,.06)",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 450,
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  media: {
    paddingTop: "65%",
  },
  link: {
    textDecoration: "none",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
}));

export default function Post({ props, isfav, cart }) {
  const {
    title,
    displayName,
    media,
    description,
    rating,
    to,
    type,
    price,
    ref,
    deliveryTime,
    available,
  } = props;

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const email = useAuth().currentUser.email;
  const [isFavorite, setIsFavorite] = useState(isfav);
  const [isInCart, setIsInCart] = useState(Object.keys(cart).includes(ref));
  const classes = useStyles();
  const [quantity, setQuantity] = useState(isInCart ? cart[ref] : 1);
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleDialogClickOpen = () => {
    setOpenDialog(true);
  };

  const handleFavoriteAction = () => {
    setIsFavorite(!isFavorite);
    if (!isFavorite) {
      db.collection("userData")
        .doc(email)
        .update({ favorites: firestore.FieldValue.arrayUnion(ref) })
        .then(console.log("PUSH"));
      setOpenSnackbar(true);
    } else {
      db.collection("userData")
        .doc(email)
        .update({ favorites: firestore.FieldValue.arrayRemove(ref) })
        .then(console.log("PUSH"));
      setOpenSnackbar(false);
    }
  };

  const handleShare = () => {
    navigator
      .share({ title: title, text: "Hello there", url: ref })
      .then(console.log("Success share"))
      .catch((err) => console.log(err));
  };

  const handleCartAction = () => {
    if (!isInCart) {
      setOpenDialog(true);
    } else {
      console.log(quantity);
      db.collection("userData")
        .doc(email)
        .update({
          cart: firestore.FieldValue.arrayRemove({
            ref: ref,
            quantity: quantity,
          }),
        })
        .then(console.log("POP"));
      setIsInCart(false);
    }
  };

  function generateRatings(ratings) {
    const stars = [];
    [...Array(Math.floor(ratings))].forEach(() => {
      stars.push(<StarRoundedIcon color="secondary" />);
    });

    if (ratings - Math.floor(ratings) >= 0.5)
      stars.push(<StarHalfRoundedIcon color="secondary" />);

    return stars;
  }

  function AlertDialog() {
    const [mQuantity, setmQuantity] = useState(1);

    const handleAddMore = () => {
      setmQuantity((initQuantity) => initQuantity + 1);
    };

    const handleRemove = () => {
      mQuantity > 1 && setmQuantity((initQuantity) => initQuantity - 1);
    };

    const handleDialogClose = () => {
      setOpenDialog(false);
      setQuantity(1);
    };

    const handleAddToCart = () => {
      db.collection("userData")
        .doc(email)
        .update({
          cart: firestore.FieldValue.arrayUnion({
            ref: ref,
            quantity: mQuantity,
          }),
        })
        .then(() => {
          console.log("PUSH");
          setQuantity(mQuantity);
          setIsInCart(true);
          setOpenDialog(false);
        });
    };

    return (
      <div>
        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle id="alert-dialog-title">{displayName}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography variant="h5">{title}</Typography>
              <Typography variant="body1">
                {`How much quantity of ${title} would you like to add?`}
              </Typography>
            </DialogContentText>
            <Container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <IconButton
                onClick={handleRemove}
                color="primary"
                disabled={mQuantity === 1}
              >
                <RemoveCircleOutlineOutlinedIcon />
              </IconButton>
              <Typography variant="h5" style={{ padding: 15 }}>
                {mQuantity}
              </Typography>
              <IconButton onClick={handleAddMore} color="primary">
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Container>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="secondary">
              Close
            </Button>
            <Button onClick={handleAddToCart} color="primary" autoFocus>
              Add to Cart
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  function SnackBar() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={`Added ${title} to favorites`}
        var
        action={
          <React.Fragment>
            <IconButton
              size="small"
              color="inherit"
              onClick={handleSnackbarClose}
            >
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    );
  }

  return (
    <>
      <SnackBar />
      <AlertDialog />
      <Link to={to} className={classes.link}>
        <Card className={classes.root} variant="outlined">
          <CardMedia className={classes.media} image={media} />
          <CardContent>
            <Grid container>
              <Grid item xs={2}>
                <Avatar
                  aria-label="recipe"
                  style={{
                    backgroundColor: type === "non-veg" ? red[500] : green[500],
                  }}
                >
                  <FiberManualRecordIcon />
                </Avatar>
              </Grid>
              <Grid item xs={10}>
                <Grid direction="row" container>
                  <Grid item xs={9}>
                    <Typography variant="h6">{title}</Typography>
                  </Grid>
                  <Grid item xs={3} align="right">
                    <Typography>{`Rs. ${price}`}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography>{displayName}</Typography>
                  </Grid>
                  <Tooltip arrow title={rating} placement="bottom">
                    <Grid item xs={6} align="right">
                      {generateRatings(rating)}
                    </Grid>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions disableSpacing>
            <IconButton
              style={{ color: isFavorite ? "#f00" : "#000" }}
              onClick={handleFavoriteAction}
            >
              <FavoriteRounded />
            </IconButton>
            <Button
              size="large"
              className={classes.action}
              disabled={!available}
              startIcon={
                isInCart ? (
                  <RemoveCircleOutlineRounded />
                ) : (
                  <AddCircleOutlineRounded />
                )
              }
              onClick={handleCartAction}
            >
              {isInCart ? "Remove" : "Add to Cart"}
            </Button>
            <IconButton onClick={handleShare}>
              <ShareRounded />
            </IconButton>
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <Typography>{`Delivery time - ${deliveryTime} mins.`}</Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                {description == ""
                  ? description
                  : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum deserunt amet vel libero assumenda eius eveniet repellat ea suscipit tempora?"}
              </Typography>
            </CardContent>
          </Collapse>
        </Card>
      </Link>
    </>
  );
}
